import React, { FC } from 'react';
import { FeedbackRating } from '@rbx/conv-ai-provider';
import { FeedbackRatingIconProps } from '../types';
import FeedbackPositiveIcon from './FeedbackPositiveIcon';
import FeedbackNegativeIcon from './FeedbackNegativeIcon';

const FeedbackRatingIcon: FC<
  React.PropsWithChildren<FeedbackRatingIconProps & { rating: FeedbackRating }>
> = ({ rating, ...iconProps }) => {
  if (rating === FeedbackRating.Positive) return <FeedbackPositiveIcon {...iconProps} />;
  if (rating === FeedbackRating.Negative) return <FeedbackNegativeIcon {...iconProps} />;
  return null;
};

export default FeedbackRatingIcon;
